import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Contract from 'modules/contracts/lib/Contract'
import { hasOngoing } from 'modules/contracts/lib/contractSchedule'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import Menu from './Menu'

interface Props {
  selectedContractVersion: ContractVersion
  allContractVersionsSorted: ContractVersion[]
  contractVersionRequest?: ContractVersionRequest | undefined
  contracts: Contract[]
  onClickEdit: () => void
  onClickFix: () => void
  onClickDelete: () => void
  toggleHistory: () => void
  employee: Employee
}

const Actions = ({
  selectedContractVersion,
  allContractVersionsSorted,
  contractVersionRequest,
  contracts,
  onClickEdit,
  onClickFix,
  onClickDelete,
  toggleHistory,
  employee,
}: Props) => {
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  const canPromote = policyAuthorizations.for('contracts.promote', employee)

  const canDeleteContracts = policyAuthorizations.for('contracts.delete_contracts', employee)
  const canSeeMenu = canEdit || canDeleteContracts
  const canUpdateContract = canEdit || (canPromote && hasOngoing(contracts))

  return (
    <Box
      gridColSpan={{ xxs: 12, xs: 6, s: 5 }}
      flexDirection="row"
      justifyContent="flexEnd"
      gap="s8"
    >
      {canUpdateContract && (
        <Box className="employee_profile_contracts_tab_new_conditions_button">
          <Button type="secondary" onClick={() => onClickEdit()} iconName="add">
            {i18n.t('contract_versions.header.new_conditions')}
          </Button>
        </Box>
      )}
      <Button type="secondary" onClick={() => toggleHistory()} iconName="clock">
        {i18n.t('contract_versions.header.history')}
      </Button>
      {canSeeMenu && (
        <Menu
          selectedContractVersion={selectedContractVersion}
          allContractVersionsSorted={allContractVersionsSorted}
          onClickFix={onClickFix}
          onClickDelete={onClickDelete}
          contractVersionRequest={contractVersionRequest}
        />
      )}
    </Box>
  )
}

export default observer(Actions)
